import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./reducers/userSlice";
import announcementReducer from "./reducers/announcementSlice";
import categoriesReducer from "./reducers/categoriesSlice";
import thunk from "redux-thunk";

export const store = configureStore({
  reducer: {
    user: userReducer,
    announcement: announcementReducer,
    categories: categoriesReducer,
  },
  middleware: [thunk],
});
